"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockMenuItem = void 0;
var mockMenuItem = {
  calories: 3000,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201342,
  itemCaloriesText: '3000 Cal',
  itemDescription: 'Four slices of Pepperoni pizza combined with eight Italian Cheese Stix, plus Crazy Sauce®',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Slices-N-Stix® (3000 Cal)',
  itemName: 'Slices-N-Stix®',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-SNS',
  menuWarnings: null,
  orderable: true,
  price: 6.5,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: '8 pieces'
};
exports.mockMenuItem = mockMenuItem;